import React from 'react';
import DaumPostCode from "react-daum-postcode";
import { useDispatch, useSelector } from 'react-redux';
import { setAddrInfo } from "../../modules/insert";
import {
  CButton,
  CRow,
  CCol,
  CLabel,
  CInput,
} from "@coreui/react";

const Addr = (props) => {
  const { handleInputChange } = props;
  const { insert } = useSelector((state) => state);
  const dispatch = useDispatch();

  // [ Start ]주소검색 로직
  const [isAddr, setIsAddr] = React.useState(false);
  const handleOpenPost = () => {
    setIsAddr(!isAddr);
  };
  // postcode
  const handleAddress = (data) => {
    let zoneCode = data.zonecode;
    let AllAddress = data.roadAddress;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      AllAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }

    dispatch(setAddrInfo({ addr: AllAddress, postNo: zoneCode }));
  };
  // [ End ]주소검색 로직

  return (
    <>
      <CRow>
        <CCol xs="12" className="text-left">
          <CLabel>
            <span>*</span>자택주소
          </CLabel>
        </CCol>
        <CCol xs="6">
          <CInput
            type="text"
            id="zoneCode"
            name="postNo"
            placeholder='우편번호'
            value={insert.reqTaskInfo.postNo || ""}
            onChange={handleInputChange}
            disabled
          />
        </CCol>
        <CCol xs="6" className="text-left">
          <CButton
            type="button"
            color="primary"
            onClick={handleOpenPost}
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          >
            검색
          </CButton>
        </CCol>
        {isAddr ? (
          <CCol xs="12">
            <DaumPostCode
              onComplete={handleAddress}
              autoClose
              // theme={themeObj}
            />
          </CCol>
        ) : null}
        <CCol xs="12" className="mb-2">
          <CLabel></CLabel>
          <CInput
            type="text"
            id="fullAddress"
            name="addr"
            placeholder='주소를 검색하세요'
            value={insert.reqTaskInfo.addr || ""}
            onChange={handleInputChange}
            disabled
          />
          <CLabel></CLabel>
          <CInput
            type="text"
            id="dtlAddr"
            name="dtlAddr"
            placeholder="상세주소"
            value={insert.reqTaskInfo.dtlAddr || ""}
            onChange={handleInputChange}
            maxLength="200"
            disabled={
              insert.reqTaskInfo.stCd === "10" ||
              insert.reqTaskInfo.stCd === "99"
                ? false
                : true
            }
          />
        </CCol>
      </CRow>
    </>
  )
};

export default React.memo(Addr);
